<script>
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit'
import 'xterm/css/xterm.css'
import { mapState, mapActions, mapMutations } from 'vuex'
import axios from 'axios'

export default {
   name: 'SicantikScrapRun',
   components: {},
   data() {
      return {
         pageList: 1,
         grandTotal: 0,
         request: null,
         term: null,
         fitAddon: null,
         loading: false,
         otp: '',
      }
   },
   computed: {
      ...mapState({
         myData: state => state.SicantikScrap.data,
         myCount: state => state.SicantikScrap.countAll,
         myCountDetail: state => state.SicantikScrap.countAllDetail,
         myCurrent: state => state.SicantikScrap.current,
         mySuccess: state => state.SicantikScrap.success,
         myFailed: state => state.SicantikScrap.failed,
         myState: state => state.SicantikScrap.runningState,
      }),
      isLoading() {
         return this.$store.state.isLoading
      },
      current: {
         get() {
            return this.myCurrent
         },
         set(value) {
            let newVal

            if (value) {
               newVal = value
            } else {
               newVal = 0
            }

            this.updateCurrent(parseInt(newVal, 10))
         },
      },
   },
   watch: {
      // loading(val) {
      //    if (val) {
      //       this.$swal({ text: 'Loading', allowOutsideClick: false })
      //       this.$swal.showLoading()
      //    } else {
      //       this.$swal.close()
      //    }
      // },
   },
   mounted() {
      // 1. Inisialisasi Terminal
      this.term = new Terminal({
         cursorBlink: true,
         fontSize: 14,
         fontFamily: 'Consolas, "Courier New", monospace',
         theme: {
            background: '#021a23',
            foreground: '#d4d4d4',
         },
      })
      // 2. Load Addon Fit
      this.fitAddon = new FitAddon()
      this.term.loadAddon(this.fitAddon)

      // 3. Pasang Terminal ke elemen DOM
      this.term.open(this.$refs.terminalContainer)

      // 4. Sesuaikan ukuran awal
      this.fitAddon.fit()

      // Tulis pesan sambutan
      // this.term.write('Xterm.js siap di Vue 2!\n\r')
      // this.term.write('$ ')

      // 5. Tambahkan Event Listener (jika Anda butuh input interaktif)
      this.term.onData(data => {
      // Anda dapat mengirim 'data' ini ke backend (misalnya melalui Socket.io atau API)
         this.term.write(data)
         if (data === '\r') {
            this.term.write('\n\r[Command received]\n\r$ ')
         }
      })

      window.addEventListener('resize', this.handleResize)

      this.getData()
         .then(result => {
            console.log(result)
         })
         .catch(error => {
            console.log(error)
         })
   },
   beforeDestroy() {
      // 6. Bersihkan (Dispose) Terminal
      // Ini sangat penting untuk mencegah memory leak di Vue 2
      window.removeEventListener('resize', this.handleResize)
      if (this.term) {
         this.term.dispose()
      }
   },
   methods: {
      ...mapActions({
         getData: 'SicantikScrap/getData',
         getDataError: 'SicantikScrap/getDataError',
         runScrap: 'SicantikScrap/runScrap',
         runScrapPermohonan: 'SicantikScrap/runScrapPermohonan',
         loginSicantik: 'SicantikScrap/loginSicantik',
         loginOtpSicantik: 'SicantikScrap/loginOtpSicantik',
      }),
      ...mapMutations({
         updateCurrent: 'SicantikScrap/SET_CURRENT',
         setState: 'SicantikScrap/SET_STATE',
         setCancelToken: 'SicantikScrap/SET_CANCEL_TOKEN',
         setReset: 'SicantikScrap/SET_RESET',
      }),
      run() {
         if (!this.myState) {
            return
         }

         // console.log(this.myData[this.myCurrent].id_permohonan)

         this.write(`Run ${this.myCurrent}`)
         this.write(`------ Body : { id_permohonan : ${JSON.stringify(this.myData[this.myCurrent].id_permohonan)}}`)

         this.runScrap(this.myData[this.myCurrent].id_permohonan).then(data => {
            if (data?.message) {
               this.write(`------ Response : \x1B[1;3;32m${JSON.stringify(data.message)}\x1B[0m `)
            } else {
               // Jika request gagal, tampilkan pesan error + body response dari server (jika ada)
               const errMessage = [
                  data?.message,
                  data?.response?.data ? JSON.stringify(data.response.data) : null,
               ].filter(Boolean).join(' | ')

               this.write(`------ Response : \x1B[1;3;31m${errMessage || JSON.stringify(data)}\x1B[0m `)
            }

            if (this.myCurrent < this.myCount) {
               this.run()
            } else {
               this.setState(false)
            }
         })
      },
      // onRunPermohonan() {
      //    this.loading = true
      //    this.runScrapPermohonan().then(() => {
      //       this.loading = false
      //    }, () => {
      //       this.loading = false
      //    })
      // },

      onRunPermohonan() {
         this.write('Start : Update List Permohonan')
         this.write(`------ Page : ${this.pageList}`)

         const axiosSource = axios.CancelToken.source()
         this.request = { cancel: axiosSource.cancel }
         this.setCancelToken(axiosSource.token)
         this.setState(true)

         this.loading = true
         this.runScrapPermohonan(this.pageList).then(
            res => {
               this.grandTotal += res.total_item
               this.write(`------ Item : ${res.total_item}`)
               this.write(`------ Total : ${this.grandTotal}`)
               this.pageList = parseInt(this.pageList, 10) + 1

               // this.$toast.success(res.message)
               this.loading = false
               this.setState(false)
               // console.log(this.pageList, this.totalPage)
               if (res.total_item === 0) {
                  this.write('Finish : Update List Permohonan')
                  this.getData()
                  this.pageList = 1
                  this.grandTotal = 0
                  this.setState(false)
               } else {
                  this.onRunPermohonan()
               }
            },
            () => {
               this.write('------ \x1B[1;3;31mGagal mendapatkan list permohonan\x1B[0m')
               this.loading = false
               this.setState(false)
            },
         )
      },
      onStart() {
         this.write('Start Run')
         const axiosSource = axios.CancelToken.source()
         this.request = { cancel: axiosSource.cancel }
         this.setCancelToken(axiosSource.token)
         this.setState(true)
         this.run()
      },
      onStop() {
         this.write('\x1B[1;3;31mStop\x1B[0m')
         this.setState(false)
         this.request.cancel()
      },
      onLoadList() {
         this.setReset()
         this.write('Start : Load list')
         this.getData()
            .then(result => {
               this.write(`------ Total : ${JSON.stringify(result.length)}`)
            // console.log(result)
            })
            .catch(error => {
               this.write(`------ ${JSON.stringify(error)}`)
            // console.log(error)
            })
      },
      onLoadListError() {
         this.setReset()
         this.write('Start : Load list error only')
         this.getDataError()
            .then(result => {
               this.write(`------ Total : ${JSON.stringify(result.length)}`)
            // console.log(result)
            })
            .catch(error => {
               this.write(`------ ${JSON.stringify(error)}`)
            // console.log(error)
            })
      },
      onLogin() {
         this.write('Login')
         this.loading = true
         this.loginSicantik().then(
            () => {
               // this.write(`------ ${res.message}`)
               // this.$toast.success(res.message)
               this.$bvModal.show('modal-form')
               this.loading = false
            },
            () => {
               this.loading = false
            },
         )
      },
      onSaveOtp() {
         this.loading = true
         this.loginOtpSicantik(this.otp.trim()).then(() => {
            this.otp = ''
            this.$bvModal.hide('modal-form')
            this.write('------ Berhasil Login')
            this.loading = false
         }, () => {
            this.write('------ Gagal Login')
            this.loading = false
         })
      },
      write(text) {
         if (this.term) {
            this.term.write(`${text}\n\r`)
         }
      },
      handleResize() {
         if (this.fitAddon) {
            this.fitAddon.fit()
         }
      },
   },
}
</script>

<template>
   <div>
      <b-row>
         <b-col cols="12" xl="4" lg="4" md="4">
            <b-card title="Jumlah">
               <b-row>
                  <b-col cols="21" xl="12" class="mb-2">
                     <div class="d-flex align-items-center mr-2">
                        <b-avatar variant="light-primary" rounded>
                           <feather-icon icon="DollarSignIcon" size="18" />
                        </b-avatar>
                        <div class="ml-1">
                           <h5 class="mb-0">
                              {{ myCountDetail }}
                           </h5>
                           <small>Total Permohonan Sicantik (yang berhasil ditarik)</small>
                        </div>
                     </div>
                  </b-col>
                  <b-col cols="21" xl="12" class="mb-2">
                     <div class="d-flex align-items-center">
                        <b-avatar variant="light-primary" rounded>
                           <feather-icon icon="TrendingUpIcon" size="18" />
                        </b-avatar>
                        <div class="ml-1">
                           <h5 class="mb-0">
                              {{ myCount }}
                           </h5>
                           <small>Total Permohonan Sicantik List</small>
                        </div>
                     </div>
                  </b-col>
               </b-row>
            </b-card>
            <b-card title="Status">
               <b-row>
                  <b-col cols="21" xl="12" class="mb-2">
                     <div class="d-flex align-items-center mr-2">
                        <b-avatar variant="light-primary" rounded>
                           <feather-icon icon="DollarSignIcon" size="18" />
                        </b-avatar>
                        <div class="ml-1">
                           <h5 class="mb-0">
                              {{ myCurrent }}
                           </h5>
                           <small>Current / Posisi</small>
                        </div>
                     </div>
                  </b-col>
                  <b-col cols="21" xl="12" class="mb-2">
                     <div class="d-flex align-items-center">
                        <b-avatar variant="light-success" rounded>
                           <feather-icon icon="TrendingUpIcon" size="18" />
                        </b-avatar>
                        <div class="ml-1">
                           <h5 class="mb-0">
                              {{ mySuccess }}
                           </h5>
                           <small>Sukses</small>
                        </div>
                     </div>
                  </b-col>
                  <b-col cols="21" xl="12" class="mb-2">
                     <div class="d-flex align-items-center">
                        <b-avatar variant="light-danger" rounded>
                           <feather-icon icon="TrendingUpIcon" size="18" />
                        </b-avatar>
                        <div class="ml-1">
                           <h5 class="mb-0">
                              {{ myFailed }}
                           </h5>
                           <small>Error</small>
                        </div>
                     </div>
                  </b-col>
                  <b-col md="12" class="mb-1">
                     <b-form-input v-model="current" :disabled="myState" type="number" placeholder="Enter Posisi" />
                  </b-col>
                  <b-col md="12" class="mb-1">
                     <b-button :disabled="isLoading" variant="secondary" block @click="onStart">
                        <span v-show="isLoading" class="spinner-border spinner-border-sm" />
                        Start
                     </b-button>
                  </b-col>
                  <b-col md="12" class="mb-1">
                     <b-button :disabled="!myState" variant="danger" block @click="onStop">
                        Stop
                     </b-button>
                  </b-col>
                  <hr>
                  <b-col md="12" class="mb-1">
                     <hr>
                     <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLogin">
                        Login
                     </b-button>
                  </b-col>
                  <b-col md="6" class="mb-1">
                     <hr>
                     <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLoadList()">
                        Load All
                     </b-button>
                  </b-col>
                  <b-col md="6" class="mb-1">
                     <hr>
                     <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLoadListError()">
                        Load Error Only
                     </b-button>
                  </b-col>
               </b-row>
            </b-card>
            <b-card title="Update List Permohonan">
               <b-row>
                  <b-col md="12" class="mb-1">
                     <b-form-input
                        v-model="pageList"
                        :disabled="myState || isLoading"
                        type="number"
                        placeholder="Page"
                        label="Page"
                     />
                  </b-col>
                  <b-col md="12" class="mb-1">
                     <b-button :disabled="isLoading" variant="secondary" block @click="onRunPermohonan">
                        <span v-show="isLoading" class="spinner-border spinner-border-sm" />
                        Update List Permohonan
                     </b-button>
                  </b-col>
               </b-row>
            </b-card>
         </b-col>
         <b-col cols="12" md="8" xl="8" lg="8">
            <b-card title="Action">
               <b-row>
                  <b-col md="12">
                     <div>
                        <!-- <label>Progress label with precision</label> -->
                        <b-progress
                           :value="myCurrent"
                           :max="myCount"
                           precision="2"
                           show-progress
                           variant="primary"
                           class="progress-bar-warning"
                        />
                     </div>
                  </b-col>
               </b-row>
            </b-card>
            <b-card title="Logs">
               <b-row>
                  <b-col md="12">
                     <div>
                        <!-- <label>Progress label with precision</label> -->
                        <div id="terminal-container" ref="terminalContainer" />
                     </div>
                  </b-col>
               </b-row>
            </b-card>
         </b-col>
      </b-row>

      <b-modal
         id="modal-form"
         cancel-variant="outline-secondary"
         ok-title="Simpan"
         cancel-title="Close"
         centered
         title="Form OTP"
         no-close-on-backdrop
         @ok="onSaveOtp"
      >
         <b-form>
            <b-form-group>
               <label for="otp">OTP:</label>
               <b-form-input id="otp" v-model="otp" type="text" placeholder />
            </b-form-group>
         </b-form>
      </b-modal>
   </div>
</template>

<style scoped>
#terminal-container {
  /* Berikan dimensi yang jelas pada kontainer */
  width: 100%;
  height: 400px;
  border: 1px solid #555;
  padding: 5px;
}
</style>
